export const selectSection = (state) => state.projects.sections;
export const selectSearch = (state) => state.projects.search;
